module.exports = __webpack_public_path__ + "static/media/google_g.0d0b1131.svg";